import I18n from "i18n-js";
import { func, shape, string } from "prop-types";
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import InstallationEditForm from "./InstallationEditForm/components/InstallationEditForm";
import {
  getInstallationInfos,
  putInstallation,
} from "../actions/installationsActions";

InstallationEdit.propTypes = {
  installations: shape(),
  info: shape(),
  onSubmit: func,
  history: shape(),
  match: shape(),
};

function InstallationEdit({ installations, info, onSubmit, history, match }) {
  if (installations.inProgress || info === undefined) {
    return <div className="loader" />;
  }

  if (installations.error) {
    return <p>{I18n.t("common.loadingApiError")}</p>;
  }
  return (
    <InstallationEditForm
      history={history}
      onSubmit={onSubmit}
      saved={installations.saved}
      info={info}
      match={match}
    />
  );
}

InstallationEditWrapper.propTypes = {
  match: shape(),
  history: shape(),
  installations: shape(),
  info: shape(),
};
export function InstallationEditWrapper({
  match,
  history,
  installations,
  info,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInstallationInfos(match.params.uuid));
  }, [dispatch, match]);

  const onSubmit = (payload) => {
    dispatch(putInstallation(match.params.uuid, payload));
  };

  return (
    <InstallationEdit
      history={history}
      installations={installations}
      info={info}
      onSubmit={onSubmit}
      match={match}
    />
  );
}

InstallationEditWrapper.propTypes = {
  history: shape().isRequired,
  match: shape({
    params: shape({
      uuid: string.isRequired,
    }).isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  installations: state.installations,
  info: state.installations.info,
});

export default connect(mapStateToProps)(InstallationEditWrapper);
